import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useCallback, useEffect, useMemo } from 'react';
import Router, { useRouter } from 'next/router';
import { createProductListingQueryParams, parseProductListingQueryParams } from './productListingParamsCustomFilters';
/**
 * This hook will update the current URL based on changes to the filter or sort
 * state.
 */

export default function useProductListingQueryParams(_ref) {
  var autoAppliedFilters = _ref.autoAppliedFilters,
      baseFilters = _ref.baseFilters,
      filters = _ref.filters,
      filterSettings = _ref.filterSettings,
      sortOption = _ref.sortOption,
      sortOptions = _ref.sortOptions,
      onQueryChange = _ref.onQueryChange,
      _ref$enabled = _ref.enabled,
      enabled = _ref$enabled === void 0 ? true : _ref$enabled,
      _ref$mySize = _ref.mySize,
      mySize = _ref$mySize === void 0 ? true : _ref$mySize;
  var router = useRouter();
  var aggregations = baseFilters.aggregations;
  var productListingParamKeys = useMemo(function () {
    // * Calculate what keys relate to the filtering/sorting and should
    // * be modified
    return new Set(['defaultTagId', // Added for Curvy page on SXF.
    'category_ids', 'avg_review_min', 'price_min', 'price_max', 'sale_price_min', 'sale_price_max', 'my_size', 'sort'].concat(_toConsumableArray(aggregations.map(function (aggregation) {
      return aggregation.field;
    }))));
  }, [aggregations]);
  var updateRoute = useCallback(function (newProductListingParams) {
    // TODO: Technically we should merge both the `Router.query` and
    // params from `Router.asPath` separately, as they can be different.
    // The current code will clobber any `query` fields that don't appear in
    // the `asPath` (such as those parsed from routes.js patterns, for
    // example).
    // Strip off any fragment first. Presumably the user has already been
    // scrolled to whatever fragment was there initially, and now it's no
    // longer necessary to persist.
    var _Router$asPath$split = Router.asPath.split('#', 1),
        _Router$asPath$split2 = _slicedToArray(_Router$asPath$split, 1),
        currentUrl = _Router$asPath$split2[0];

    var _currentUrl$split = currentUrl.split('?'),
        _currentUrl$split2 = _slicedToArray(_currentUrl$split, 2),
        currentPathname = _currentUrl$split2[0],
        currentParams = _currentUrl$split2[1];

    var newParams = new URLSearchParams(currentParams); // * Set the new values (existing ones will be overwritten)

    var _iterator = _createForOfIteratorHelper(newProductListingParams),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ref8 = _step.value;

        var _ref3 = _slicedToArray(_ref8, 2);

        var paramKey = _ref3[0];
        var paramVal = _ref3[1];
        newParams.set(paramKey, paramVal);
      } // * Remove params that no longer exist

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(newParams),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _ref9 = _step2.value;

        var _ref5 = _slicedToArray(_ref9, 1);

        var _paramKey = _ref5[0];

        // * Only modify it if the current param is related to filtering/sort
        if (productListingParamKeys.has(_paramKey) && !newProductListingParams.has(_paramKey)) {
          newParams["delete"](_paramKey);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var newQueryString = newParams.toString();
    var asPath = newQueryString ? "".concat(currentPathname, "?").concat(newQueryString) : currentPathname; // Convert from URLSearchParams to support older versions of Nextjs (SXF)
    // TODO: Remove when all reliant versions are upgraded to >= 9.5.0
    // TODO: https://github.com/vercel/next.js/commit/3369d67bd1bc495462c587ec12c346c3172b0359

    var query = {};

    var _iterator3 = _createForOfIteratorHelper(newParams),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _ref10 = _step3.value;

        var _ref7 = _slicedToArray(_ref10, 2);

        var key = _ref7[0];
        var value = _ref7[1];
        query[key] = value;
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }

    Router.replace({
      pathname: Router.pathname,
      query: query
    }, asPath, // * Change the location without actually reloading the route
    {
      shallow: true
    });
  }, [productListingParamKeys]); // * Update the URL based on the filter/sort state (or vice versa)

  useEffect(function () {
    // Send the current URL params through a parse + create round-trip: what
    // params do we end up with?
    if (enabled) {
      var currentParamFilters = parseProductListingQueryParams(router.query, {
        baseFilters: baseFilters,
        filterSettings: filterSettings,
        sortOptions: sortOptions
      });
      var currentParams = createProductListingQueryParams({
        baseFilters: baseFilters,
        filters: currentParamFilters.filters,
        filterSettings: filterSettings,
        sortOption: currentParamFilters.sortOption,
        mySize: currentParamFilters.mySize
      }); // Now create params for the current filters...

      var currentFilterParams = createProductListingQueryParams({
        autoAppliedFilters: autoAppliedFilters,
        baseFilters: baseFilters,
        filterSettings: filterSettings,
        filters: filters,
        sortOption: sortOption,
        mySize: mySize
      }); // If the current filter params don't match the current URL params,
      // update the URL!

      if (currentParams.toString() !== currentFilterParams.toString()) {
        if (onQueryChange) {
          onQueryChange(currentFilterParams);
        } // * The route update here is needed for non filter


        updateRoute(currentFilterParams);
      }
    }
  }, [autoAppliedFilters, baseFilters, enabled, filters, filterSettings, mySize, onQueryChange, router.query, sortOption, sortOptions, updateRoute]);
}